// React
import React from "react";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./AuthFlexContainer.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
const AuthFlexContainer = (props) => {
    return (React.createElement("div", { className: styles.container }, props.children));
};
export default AuthFlexContainer;
